import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import { companyAPI } from "../services/api";
import DisclaimerPopup from "./DisclaimerPopup";
import LogoIcon from "../components/LogoIcon";

const suggested = [
  { name: "Tata Steel", symbol: "TATASTEEL" },
  { name: "TCS", symbol: "TCS" },
  { name: "Tata Teleservices", symbol: "TTML" },
  { name: "Tata Consumer", symbol: "TATACONSUM" },
  { name: "Tata Power", symbol: "TATAPOWER" },
  { name: "Tata Elxsi", symbol: "TATAELXSI" },
  { name: "Tata Chemicals", symbol: "TATACHEM" },
  { name: "Tata Communications", symbol: "TATACOMM" },
  { name: "Tata Investment", symbol: "TATAINVEST" },
  { name: "Tata Tech", symbol: "TATATECH" },
];

const Home = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // 🔥 SINGLE WORKING SEARCH — EXACTLY LIKE SCREENER
  useEffect(() => {
    const timer = setTimeout(() => {
      if (query.trim().length >= 1) {
        companyAPI.searchCompanies(query)
          .then((list) => {
            console.log("Search results:", list);
            setResults(list); 
            setShowDropdown(list.length > 0);
          })
          .catch((err) => console.error("Search error:", err));
      } else {
        setResults([]);
        setShowDropdown(false);
      }
    }, 200); // Screener uses ~150ms debounce

    return () => clearTimeout(timer);
  }, [query]);

  const handleSelectCompany = (item) => {
    if (!item.symbol) return;
    navigate(`/company/${item.symbol.toUpperCase()}`);
    setQuery("");
    setShowDropdown(false);
  };

  const handleSuggestedClick = (symbol) => {
    navigate(`/company/${symbol.toUpperCase()}`);
  };

  return (
    <>
    {/* <DisclaimerPopup
      position="bottom-right"
      intervalMinutes={3}
      autoCloseSeconds={10}
      message="Financial charts are based on publicly available data and are for informational purposes only."
    /> */}
    <DisclaimerPopup
  message="Financial charts are based on publicly available data and are for informational purposes only."
  intervalMinutes={1}   // every 6 seconds
  autoCloseSeconds={5}
  position="bottom-right"
/>
    <div className="home-hero">
      <div className="home-hero-inner">

        <div className="home-logo-block">
          <div className="home-logo-mark">
           <LogoIcon />
          </div>
          <h1 className="home-logo-text">StockAnalyzer</h1>
        </div>

        <p className="home-tagline">
          Stock analysis and screening tool for investors in India.
        </p>

      {/* Search Bar */}
<div className="home-search-wrap">
  <div className="home-search-box">
    <span className="home-search-icon">🔍</span>
    <input
      type="text"
      className="home-search-input"
      placeholder="Search for a company"
      value={query}
      onChange={(e) =>  {
    const value = e.target.value;
    setQuery(value);

    // 👇 hide dropdown when input becomes empty
    if (value.trim().length === 0) {
      setResults([]);
      setShowDropdown(false);
    }
  }}
     onFocus={() => results.length > 0 && setShowDropdown(true)}
    />
  </div>

 {showDropdown && results.length > 0 && (
  <div className="home-search-dropdown">
    {results.map((item, index) => (
      <div
        key={index}
        className="home-dropdown-item"
        onClick={() => handleSelectCompany(item)}
      >
        {item.name}
      </div>
    ))}
  </div>
)}
  {/* 🔥 Suggested (Now RIGHT BELOW Search Bar) */}
  <div className="home-suggest-list">
    {suggested.map((item) => (
      <button
        key={item.symbol}
        type="button"
        className="home-suggest-chip"
        onClick={() => handleSuggestedClick(item.symbol)}
      >
        {item.name}
      </button>
    ))}
  </div>
</div>
</div>
    </div>
    </>
  );
};

export default Home;
